import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";

const STEPS = [
  { n: "01", t: "Line", d: "Define with a liner a touch deeper than your natural lip." },
  { n: "02", t: "Melt", d: "Press in Melt Lip Oil to cushion and hydrate." },
  { n: "03", t: "Glaze", d: "Finish with Glasshouse Gloss for mirror-like shine." },
];

export function Ritual() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="ritual" ref={ref} className="py-24 lg:py-36 bg-[#F4EFE6]" data-testid="ritual-section">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-14 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative aspect-[4/5] rounded-[28px] overflow-hidden">
            <motion.img style={{ y, scale: 1.15 }} src="/images/oil.jpg" alt="Melt Lip Oil on cream silk" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
          </div>
        </div>
        <div className="lg:col-span-7 order-1 lg:order-2 lg:pl-10">
          <Reveal>
            <p className="overline text-[#6E504A]">The 30-second ritual</p>
            <h2 className="font-display text-5xl sm:text-6xl mt-5 leading-[0.95]">Line. Melt. <span className="italic text-[#D88B94]">Glaze.</span></h2>
          </Reveal>
          <div className="mt-14 divide-y divide-[#E6D7CC] border-y border-[#E6D7CC]">
            {STEPS.map((s, i) => (
              <Reveal key={s.n} delay={i * 0.1}>
                <div className="group grid grid-cols-[56px_1fr] sm:grid-cols-[80px_160px_1fr] gap-x-4 gap-y-1 py-7 items-baseline" data-testid={`ritual-step-${s.n}`}>
                  <span className="font-mono-lumi text-sm text-[#6E504A]">{s.n}</span>
                  <span className="font-display text-4xl transition-transform duration-500 group-hover:translate-x-2">{s.t}</span>
                  <span className="col-start-2 sm:col-start-3 text-[#6E504A] leading-relaxed">{s.d}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
